import { computed, ref } from '@vue/composition-api';
import { iReview } from '@/entities/review/review.types';
import { iUser } from '@/entities/user/user.types';
import { ObjectLike } from '@/types/objectlike.types';

export default function ($store: any, reviewActionsVariables: ObjectLike) {
  const hasLike = computed(() => {
    const { reviewInstance } = reviewActionsVariables;
    if (!reviewInstance.value) {
      return false;
    }

    const review = reviewInstance.value as iReview;

    const storeUser: iUser = $store.getters['user/user'];
    return Boolean(review.likes.find((li) => li.userId === storeUser.id));
  });

  const likeColor = computed(() => (hasLike.value ? 'success' : 'default'));
  const likeIcon = computed(() => (hasLike.value ? 'thumb-up' : 'thumb-up-outline'));
  const likeClicked = ref(false);

  return {
    likeColor,
    likeIcon,
    likeClicked,
    hasLike,
  };
}
